"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var destroyFns = [];
var _default = destroyFns;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/modal/destroyFns.js
// module id = 982
// module chunks = 0